import { useIsLoggedIn } from "Flocknote/stateHooks";

import { useIsMemberPortal } from "CrossFeatureComponents/MemberToolbar/stateHooks";

import HomeButton from "./HomeButton";
import MemberPortalNavButton from "./MemberPortalNavButton";

const LeftNavButton = () => {
  const isLoggedIn = useIsLoggedIn();
  const isMemberPortal = useIsMemberPortal();

  if (isMemberPortal) {
    return <MemberPortalNavButton show={true} />;
  }

  return <HomeButton show={isLoggedIn} />;
};

export { LeftNavButton };
